import { Box } from '@mui/material'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRootRoute, type NotFoundRouteProps, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { DotStream } from 'ldrs/react'
import { useAuthRedirect } from '@/shared/hooks'
import { RouteMeta } from '@/shared/route-meta/routeMeta'
import { MaintenancePage } from '@/shared/ui/maintenance'
import { NotFound } from '@/shared/ui/not-found'

const MODE = import.meta.env.VITE_MODE
const MAINTENANCE_MODE =
  import.meta.env.VITE_MAINTENANCE_MODE === 'true' || import.meta.env.VITE_MAINTENANCE_MODE === '1'

const RootLayout = () => {
  useAuthRedirect()

  // Если режим обслуживания активен, не выполняем редиректы и не рендерим другие компоненты
  if (MAINTENANCE_MODE) {
    return <MaintenancePage />
  }

  return (
    <>
      <RouteMeta />
      <Outlet />
      {MODE === 'dev' && <TanStackRouterDevtools />}
      {MODE === 'dev' && <ReactQueryDevtools initialIsOpen={false} />}
    </>
  )
}

const PendingFallback = () => (
  <Box
    sx={{
      minHeight: '100vh',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <DotStream size={64} speed={1.5} color="#000000" />
  </Box>
)

const NotFoundWrapper = (_: NotFoundRouteProps) => <NotFound />

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundWrapper,
  pendingComponent: PendingFallback,
  wrapInSuspense: true,
})
